<div class="container">
    <tam-dialog tid="filter-dialog" [opened]="dialogOpened" [dialogWidth]="684" [titleName]="'Filter'">
        <ng-template #title tid="filter-title">
            <span class="dialog-title">Advanced Filtering</span>
            <smart-icon tid="filter-close" class="dark dialog-close" name="close" (click)="onCancelClicked()">
            </smart-icon>
        </ng-template>

        <ng-template #body tid="filter-body">
            <div class="filter-body-container">
                <div class="filter-header-div">
                    <Label class="subtitle">Show if</Label>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [(ngModel)]="filterLogic"
                        [data]="filterLogicOptionDropdown" tid="filter_dlg_show_if">
                    </kendo-dropdownlist>
                    <Label class="subtitle">of the following filters match.</Label>
                </div>
                <div class="filters-body-div">
                    <filter-panel [config]="filerPanelConfig"></filter-panel>
                </div>
                <div class="icon-add-bottom" tid="filter-add">
                    <div class="icon-plus">
                        <kendo-dropdownbutton [data]="filterSource" [textField]="'textField'" [iconClass]="'k-button'">
                        </kendo-dropdownbutton>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <div class="footer-div">
                <div class="anotherLeft">
                    <button tam-button tid="filter-reset" [tamType]="'tertiary'" [tamSize]="'normal'"
                        (click)="onBtnReset()">Reset</button>
                </div>
                <div class="anotherRight">
                    <button class="button-suspend" tid="filter-suspend" tam-button [tamType]="'destructive'"
                        [tamSize]="'normal'" (click)="onSuspendClicked()">Suspend</button>
                    <button tam-button tid="filter-apply" [tamType]="'primary'" [tamSize]="'normal'"
                        (click)="onApplyClicked()">Apply</button>
                </div>
            </div>
        </ng-template>
    </tam-dialog>
</div>